<div class="main-container">
  <div class="inside-main-container">
    <div [ngSwitch]="machineSessioned.maC_ModelloSx">
      <app-analysis-lcd *ngSwitchDefault></app-analysis-lcd>
      <app-analysis-touch *ngSwitchCase="3"></app-analysis-touch>
      <app-analysis-touch *ngSwitchCase="5"></app-analysis-touch>
    </div>
  </div>
</div>
